import { render, staticRenderFns } from "./press.vue?vue&type=template&id=d754eae2&"
import script from "./press.vue?vue&type=script&lang=js&"
export * from "./press.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports